import client from "../data/client";
import StartVideoUploadMutation from '../data/mutations/StartVideoUploadMutation';
import FinishVideoUploadMutation from '../data/mutations/FinishVideoUploadMutation';
import uploadFile from "./uploadFile";
import { getUploadProgress } from "./UploadProgress";

type UserVideo = {
  _id: string;
  uri: string;
};

const startVideoUpload = async (file: File, cb: (err: Error | null, res?: UserVideo) => void) => {
  const { data } = await client.mutate({
    mutation: StartVideoUploadMutation,
    fetchPolicy: 'no-cache',
    variables: {
      type: '',
    },
  });

  if (data?.userVideo?.startUpload) {
    const uploadId = data?.userVideo?.startUpload?._id;
    const url = data?.userVideo?.startUpload?.url;
    const progress = getUploadProgress(uploadId, 0);

    uploadFile(url, file, (value) => {
      progress(value / 100);
    }).then(async () => {
      const result = await client.mutate({
        mutation: FinishVideoUploadMutation,
        fetchPolicy: 'no-cache',
        variables: { userVideoId: uploadId },
      });
      progress(1);
      if (result?.data?.userVideo?.finishUpload) {
        // Callback with resulting upload.
        cb(null, result.data.userVideo.finishUpload);
      } else {
        cb(null);
      }
    }).catch(() => {
      progress(1);
      cb(null);
    });

    return uploadId;
  }
}

export default startVideoUpload;
